<router-outlet></router-outlet>
<app-notification />
<app-confirmation-dialog />
<app-session-ended-banner />
<app-connection-error />
<app-install-pwa-hint />
